module.exports = __webpack_public_path__ + "img/oil-barrel.469df5a3.svg";